import { ImageCircle, type ImageCircleStyling } from '$components'
import { Text } from '$components'
import { LinkIcon } from '$icons'
import { Link } from 'react-router-dom'

export type EntityLinkProps = {
  children: string,
  path: string,
  image?: string,
  iconSize?: ImageCircleStyling['size']
}

export function EntityLink({ children, path, image, iconSize = 'sm' }: EntityLinkProps) {

  return (
    <Link
      to={path}
      className="flex items-center gap-2 group w-fit"
    >
      { image && (
        <div className="flex items-center gap-2">
          <ImageCircle
            image={image!}
            size={iconSize}
          />
        </div>
      )}

      <Text
        type="s"
        className="group-hover:text-gray-900"
      >
        { children }
      </Text>

      <LinkIcon className="size-4 text-gray-600 group-hover:text-gray-900" />
    </Link>
  )
}
